import testImage1 from "../../img/testImage1.png";
import testImage2 from "../../img/testImage2.png";
import testImage3 from "../../img/testImage3.png";
import testImage4 from "../../img/testImage4.png";
import content from "../../Content/content.js";

export const CARD = [
    {
      key: "oct1",
      img: testImage1,
      header: content.events.calendar.test1Header,
      alt: "First test image alternative",
      day: "30",
      month: "OCT",
    },
    {
      key: "oct2",
      img: testImage2,
      header: content.events.calendar.test2Header,
      alt: "Second test image alternative",
      day: "30",
      month: "OCT",
    },
    {
      key: "oct2",
      img: testImage3,
      header: content.events.calendar.test2Header,
      alt: "Second test image alternative",
      day: "30",
      month: "OCT",
    },
    {
      key: "oct2",
      img: testImage4,
      header: content.events.calendar.test2Header,
      alt: "Second test image alternative",
      day: "30",
      month: "OCT",
    },
];
